<div id="acom">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="inner-card">
                    <h4 class="card-title ">School Magazine</h4>
                    <div class="card-body text-justify">
                        <iframe allowfullscreen="allowfullscreen" scrolling="no" class="fp-iframe" src="https://heyzine.com/flip-book/0deb66b7b6.html" style="border: 1px solid lightgray; width: 100%; height: 564px;"></iframe>
                       <!-- <div class="row text-center">
                           <div class="col-12">
                            <a  href="/assets/img/glimpses/1.png" data-lightbox="magazine"><img src="/assets/img/glimpses/1.png" alt="Magazine" class="img-fluid rounded"></a>
                            </div>
                       </div> -->
                    </div>
                </div>

            </div>
        </div>

       
    </div>
</div>